// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__OL3oE","error":"Textarea_error__1rZkU","readonly":"Textarea_readonly__2tWoe","disabled":"Textarea_disabled__1hEjK"};